import React from 'react';
import PropTypes from 'prop-types';
import RichTextDisplayPicker from 'Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';
import { FDStack } from '@facet-wealth/design';
import ManagedAccountDisclaimersMessagePicker from './ManagedAccountDisclaimerMessagePicker/ManagedAccountDisclaimerMessagePicker';

const ManagedAccountDisclaimersMessageContent = ({
  messageResource,
}) => {
  return (
    <FDStack spacing={2} direction={'column'}>
      <RichTextDisplayPicker content={messageResource.attr('content')} resource={messageResource} />
      <ManagedAccountDisclaimersMessagePicker resource={messageResource} />
    </FDStack>
  );
};

ManagedAccountDisclaimersMessageContent.defaultProps = {
};

ManagedAccountDisclaimersMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
};


export default ManagedAccountDisclaimersMessageContent;
